
export const IMPORTANCE_BUTTONS = [
  {
    value: 'not-important',
    label: 'Not important at all',
    moreInfo: ''
  },
  {
    value: 'somewhat-important',
    label: 'Somewhat important',
    moreInfo: ''
  },
  {
    value: 'very-important',
    label: 'Very important',
    moreInfo: ''
  }
];

